import { graphql } from 'react-relay';
import type { GraphQLTaggedNode } from 'react-relay';

import { useEditorContentFragment } from '@confluence/editor-content-unified-query/entry-points/useEditorContentFragment.ts';
import type { EditorContentFragmentResult } from '@confluence/editor-content-unified-query/entry-points/useEditorContentFragment.ts';

import type { FavouriteButtonComponentQuery$data } from './__generated__/FavouriteButtonComponentQuery.graphql.ts';
import type { useFavouriteContentFragment_content$key } from './__generated__/useFavouriteContentFragment_content.graphql.ts';

const favouriteContentFragmentNode: GraphQLTaggedNode = graphql`
	fragment useFavouriteContentFragment_content on Content @catch {
		id
		type
		metadata {
			currentuser {
				favourited {
					isFavourite
				}
			}
		}
		operations {
			operation
			targetType
		}
	}
`;

export function useFavouriteContentFragment({
	contentId,
}: {
	contentId: string;
}): EditorContentFragmentResult<FavouriteButtonComponentQuery$data> {
	return useEditorContentFragment<
		useFavouriteContentFragment_content$key,
		FavouriteButtonComponentQuery$data // Map to existing shape
	>('favouriteContentFragment', favouriteContentFragmentNode, {
		contentId,
		mapData: (value) => ({
			singleContent: value,
			contentOperations: value,
		}),
	});
}
